import type { HsPlane } from '../../../math-new/shapes/plane.class';

export namespace HsShaderClippingFunctions {
  export function makeUniformArrays(clippingPlanes: HsPlane[]): string {
    if (clippingPlanes.length === 0) {
      return '';
    }
    return `uniform vec4 u_clippingPlanes[${clippingPlanes.length}];\n`;
  }

  export function makeClippingCode(clippingPlanes: HsPlane[]): string {
    let code: string = '';
    for (let i: number = 0; i < clippingPlanes.length; i++) {
      code += addPlaneCode(i);
    }
    return code;
  }

  function addPlaneCode(index: number): string {
    return `if (dot(v_position.xyz, u_clippingPlanes[${index}].xyz) > u_clippingPlanes[${index}].w) discard;\n`;
  }
}
